export default "__VITE_ASSET__BE8hlIV5__"